export const lockBody = (lock: boolean) => {
  const body = document.body;

  if (lock) {
    body.classList.add('no-scroll');
  } else {
    body.classList.remove('no-scroll');
  }
};
